<template>
  <div>
    <h1>PAGE1</h1>

    <button @click="toPage2">toPage2</button>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$jsBridge.callHandler("dispatchBackBtn");
    this.$jsBridge.registerhandler("onBackPressed", () => {
      this.$jsBridge.commonCall("finish", "");
    });
  },
  methods: {
    toPage2() {
      this.$router.push({
        name: "page2",
        params: {
          name: "aaaa",
        },
      });
    },
  },
};
</script>

<style></style>
